import React from "react";
import { hasRichContent } from "../utils/richText";
const logo = process.env.PUBLIC_URL + "/img/temdyuslogo.png";
export const Header = (props) => {
  return (
    <header id="header" style={{ marginTop: "10px" }}>
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row ">
              <div className="col-md-8 col-md-offset-2 intro-text  mt-lg ">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "0px",
                  }}
                >
                  <img
                    src={logo}
                    alt="Logo"
                    style={{ maxWidth: "320px", width: "100%", height: "auto" }}
                  />
                </div>
                <h2 className="intro-title">
                  {props.data ? props.data.title : "Loading"}
                </h2>
                <h3 className="intro-subtitle">
                  {props.data ? props.data.title2 : "Loading"}
                </h3>
                {hasRichContent(props.data?.paragraph) ? (
                  <div className="intro-paragraph" dangerouslySetInnerHTML={{ __html: props.data.paragraph }} />
                ) : null}
                <a
                  href="#services"
                  className="btn btn-custom page-scroll intro-cta"
                >
                  Daha Fazlası <span className="intro-cta__arrow">→</span>
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
